/* Product deck (§10.5): finish swatches. A swatch tints the card's panel (34% into cloud), shows the
   finish name, points the card link at ?variant= and swaps to that variant's image when it has one.
   The deal itself is CSS on --pp; focus scrolling is handled by [data-pin-focus] in global.js. */
class ProductDeck extends HTMLElement {
  connectedCallback() {
    this.onClick = (event) => {
      const swatch = event.target.closest('.dcard__swatch');
      if (swatch && this.contains(swatch)) this.select(swatch);
    };
    this.addEventListener('click', this.onClick);
    this.querySelectorAll('.dcard__swatch[aria-pressed="true"]').forEach((swatch) => this.tint(swatch));
  }

  select(swatch) {
    const card = swatch.closest('[data-deck-card]');
    card.querySelectorAll('.dcard__swatch').forEach((other) => other.setAttribute('aria-pressed', String(other === swatch)));
    const name = card.querySelector('[data-finish-name]');
    if (name) name.textContent = swatch.dataset.finish;
    const link = card.querySelector('[data-card-link]');
    if (link && swatch.dataset.url) link.href = swatch.dataset.url;
    const image = card.querySelector('[data-card-media] img');
    if (image && swatch.dataset.src) {
      image.srcset = swatch.dataset.srcset;
      image.src = swatch.dataset.src;
    }
    this.tint(swatch);
  }

  // Only plain colors tint the panel; image swatches leave the default fog.
  tint(swatch) {
    const panel = swatch.closest('[data-deck-card]').querySelector('[data-panel]');
    const color = swatch.style.getPropertyValue('--swatch').trim();
    if (color && !color.startsWith('url(')) panel.style.setProperty('--tint', color);
    else panel.style.removeProperty('--tint');
  }
}

if (!customElements.get('product-deck')) customElements.define('product-deck', ProductDeck);
